import { Box } from '@mui/material';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { SubmitButton } from '../../../foundation/form/buttons/submit-button';
import { FormContainer } from '../../../foundation/layout/form-container';
import { FormField } from '../../../foundation/form/form-field';
import { FieldWrapper } from '../../../foundation/layout/field-wrapper';
import type { ExchangeId } from '@shared/types';

export type AddExchangeFormState = {
  exchangeId: ExchangeId;
};

export type AddExchangeFormProps = {
  onSubmit: (state: AddExchangeFormState) => void;
};

export const AddExchangeForm: FC<AddExchangeFormProps> = ({ onSubmit }) => {
  const formApi = useForm<AddExchangeFormState>();

  const { handleSubmit, setValue } = formApi;

  return (
    <FormProvider {...formApi}>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ height: 150 }}
      >
        <FormContainer>
          <FormField
            type="exchange"
            name="exchangeId"
            onChange={(_, newValue) => {
              setValue('exchangeId', newValue as ExchangeId);
            }}
          />

          <FieldWrapper>
            <SubmitButton />
          </FieldWrapper>
        </FormContainer>
      </Box>
    </FormProvider>
  );
};
